import { createFileRoute } from '@tanstack/react-router'

import { PageCard, PageLayout } from '@/components/ui/page'

import { UnitCreateForm } from '@/features/unit/components/unit-form'

export const Route = createFileRoute('/_app/inventory/unit/create')({
	component: RouteComponent,
})

function RouteComponent() {
	return (
		<PageLayout>
			<PageLayout.Header
				breadcrumbs={[
					['/inventory', 'Inventory'],
					['/inventory/unit', 'Konversi Unit'],
					['/inventory/unit/create', 'Tambah Konversi'],
				]}
			/>
			<PageCard>
				<PageCard.Header title="Buat Konversi Unit" />
				<PageCard.Content>
					<UnitCreateForm />
				</PageCard.Content>
			</PageCard>
		</PageLayout>
	)
}
